/* XTS Internal: This file is autogenerated by the build system. To update use codegen */
import type * as Types from '../../../../src/interfaces/xingOne';

import type { DocumentNode } from 'graphql';
import * as Apollo from '@apollo/client';
const defaultOptions = {};
export type NewXbmGetLoggedInUserDataQueryVariables = Types.Exact<{
  [key: string]: never;
}>;

export type NewXbmGetLoggedInUserDataQuery = {
  viewer?: Types.Maybe<
    Pick<Types.Viewer, 'featureSwitches'> & {
      profile?: Types.Maybe<
        Pick<Types.XingId, 'id' | 'firstName' | 'lastName' | 'displayName'> & {
          profileImage?: Types.Maybe<
            Array<Types.Maybe<Pick<Types.ProfileImage, 'url'>>>
          >;
          occupations?: Types.Maybe<
            Array<Types.Maybe<Pick<Types.XingIdOccupation, 'headline'>>>
          >;
        }
      >;
      accountSettings?: Types.Maybe<{
        language?: Types.Maybe<Pick<Types.SelectSetting, 'value'>>;
        email?: Types.Maybe<Pick<Types.EmailSetting, 'active'>>;
      }>;
      features?: Types.Maybe<
        Pick<Types.Feature, 'isXingEmployee' | 'isCraUser' | 'isXtpUser'>
      >;
    }
  >;
  erecruitingSourcingServiceBriefingList?: Types.Maybe<
    Pick<Types.ErecruitingSourcingServiceBriefingListResponse, 'total'>
  >;
};

export const NewXbmGetLoggedInUserDataDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'newXbmGetLoggedInUserData' },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'viewer' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  alias: { kind: 'Name', value: 'profile' },
                  name: { kind: 'Name', value: 'xingId' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'firstName' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'lastName' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'displayName' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'profileImage' },
                        arguments: [
                          {
                            kind: 'Argument',
                            name: { kind: 'Name', value: 'size' },
                            value: { kind: 'EnumValue', value: 'SQUARE_128' },
                          },
                        ],
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'url' },
                            },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'occupations' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'headline' },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'accountSettings' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'language' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'value' },
                            },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'email' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'active' },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'features' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'isXingEmployee' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'isCraUser' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'isXtpUser' },
                      },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'featureSwitches' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: {
              kind: 'Name',
              value: 'erecruitingSourcingServiceBriefingList',
            },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'total' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;

/**
 * __useNewXbmGetLoggedInUserDataQuery__
 *
 * To run a query within a React component, call `useNewXbmGetLoggedInUserDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useNewXbmGetLoggedInUserDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useNewXbmGetLoggedInUserDataQuery({
 *   variables: {
 *   },
 * });
 */
export function useNewXbmGetLoggedInUserDataQuery(
  baseOptions?: Apollo.QueryHookOptions<
    NewXbmGetLoggedInUserDataQuery,
    NewXbmGetLoggedInUserDataQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    NewXbmGetLoggedInUserDataQuery,
    NewXbmGetLoggedInUserDataQueryVariables
  >(NewXbmGetLoggedInUserDataDocument, options);
}
export function useNewXbmGetLoggedInUserDataLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    NewXbmGetLoggedInUserDataQuery,
    NewXbmGetLoggedInUserDataQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    NewXbmGetLoggedInUserDataQuery,
    NewXbmGetLoggedInUserDataQueryVariables
  >(NewXbmGetLoggedInUserDataDocument, options);
}
export type NewXbmGetLoggedInUserDataQueryHookResult = ReturnType<
  typeof useNewXbmGetLoggedInUserDataQuery
>;
export type NewXbmGetLoggedInUserDataLazyQueryHookResult = ReturnType<
  typeof useNewXbmGetLoggedInUserDataLazyQuery
>;
export type NewXbmGetLoggedInUserDataQueryResult = Apollo.QueryResult<
  NewXbmGetLoggedInUserDataQuery,
  NewXbmGetLoggedInUserDataQueryVariables
>;
